import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getContractDates } from "utils/contract";
import { EField, IExtraData } from "./schema.createDocument.types";

export const getInitialValues = ({
  document,
  files,
  contractId,
}: IExtraData): IValues => {
  if (document) {
    return {
      [EField.Name]: document.filename,
      [EField.Category]: document.categoryId,
      [EField.Contract]: contractId || "-1",
    };
  }

  if (files) {
    return {
      [EField.Name]: files[0].name,
      [EField.Contract]: "-1",
    };
  }

  return {};
};

export const getContractOptions = (extraData: IExtraData) => {
  const contractDates = (extraData.contracts || []).map(contract => ({
    id: contract?.id,
    value: getContractDates(contract),
  }));
  return [
    { id: "-1", value: getLocalizedText("system.none") },
    ...contractDates,
  ];
};
